import {Component} from 'react';
import ReactDOM from 'react-dom';

import * as EditableListUtil from 'notebook/mediocre/selection/text/EditableListUtil';
import {EditableListProps} from 'notebook/mediocre/selection/text/EditableListUtil';

interface EditableListMixinState {
  [key: string]: unknown;
}

// Define the component type that uses this mixin
interface EditableListComponent<P extends EditableListProps = EditableListProps, S = EditableListMixinState>
  extends Component<P, S> {
  selection?: BenchlingSelection | null;
  setSelection: (selection: BenchlingSelection | null) => void;
  clearSelection: () => void;
}

export default {
  clearSelection<P extends EditableListProps, S>(this: EditableListComponent<P, S>): void {
    EditableListUtil.clearSelection(this.setSelection);
  },

  UNSAFE_componentWillMount<P extends EditableListProps, S>(this: EditableListComponent<P, S>): void {
    this.clearSelection();
  },

  setSelection<P extends EditableListProps, S>(
    this: EditableListComponent<P, S>,
    selection: BenchlingSelection | null
  ): void {
    // Save the desired selection, to be set on component update.
    this.selection = selection;
  },

  componentDidMount<P extends EditableListProps, S>(this: EditableListComponent<P, S>): void {
    const rootNode = ReactDOM.findDOMNode(this) as Element;
    EditableListUtil.editableListDidMount(rootNode, this.props, this.setSelection);
  },

  componentDidUpdate<P extends EditableListProps, S>(
    this: EditableListComponent<P, S>,
    prevProps: P,
    prevState: S
  ): void {
    const rootNode = ReactDOM.findDOMNode(this) as Element;
    EditableListUtil.editableListDidUpdate(
      rootNode,
      prevProps,
      this.props,
      this.selection || null,
      this.setSelection
    );
  },
};
